import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';

import { SharedModule } from '@royalty/module';

import { KeyboardDialogComponent } from "./keyboard.dialog.component";
import { DirectiveModule } from "../directive/directive.module";

@NgModule({
	declarations: [
		KeyboardDialogComponent
	],
	providers: [],
	imports: [
		MatButtonModule,
		MatDialogModule,
		MatInputModule,
		SharedModule,
		DirectiveModule
	],
	entryComponents: [
		KeyboardDialogComponent
	],
	schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class KeyboardDialogModule { }
